import React from 'react';
import PropTypes from 'prop-types';
import Text from '../containers/Text';
import Icon from './Icon';

const IconButton = ({text, icon, onClick}) => {
  return (
      <button onClick={e=>onClick(e)} className="btn btn-link btn-sm">
        <Icon icon={icon} />
        {' '} <Text id={text} />
      </button>
  );
};

IconButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default IconButton;
